
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.414 43.643a.988.988 0 01-.71-1.692l11.668-11.619-11.698-11.648a.988.988 0 010-1.404.999.999 0 011.41 0l12.398 12.345a.988.988 0 010 1.404L25.114 43.344a.934.934 0 01-.7.299z"}}),_c('path',{attrs:{"d":"M29.723 52.713c-12.408 0-22.496-10.046-22.496-22.4 0-12.356 10.088-22.401 22.496-22.401s22.497 10.045 22.497 22.4c0 12.355-10.089 22.4-22.497 22.4zm0-42.81c-11.298 0-20.497 9.16-20.497 20.41s9.199 20.409 20.497 20.409 20.497-9.16 20.497-20.41S41.03 9.903 29.723 9.903z"}})])
          )
        }
      }
    